<div class="help-button-container" #helpButtonContainer>
  <button
    mat-fab
    #helpButton
    color="primary"
    [matMenuTriggerFor]="helpMenu"
    draggable="true"
    (drag)="onDrag()"
  >
    ?
  </button>
</div>

<mat-menu #helpMenu="matMenu">
  <a mat-menu-item href="http://status.patientpal.com" target="_blank">
    <mat-icon>offline_bolt</mat-icon>
    PatientPal Status
  </a>
  <a mat-menu-item [href]="app.supportUrl" target="_blank">
    <mat-icon>help</mat-icon>
    Launch service desk
  </a>
  <a mat-menu-item href="https://ppal.atlassian.net/wiki/spaces/KB/pages/8683523/Help+Articles" target="_blank">
    <mat-icon>help_center</mat-icon>
    PatientPal Help Center
  </a>
  <a
    mat-menu-item
    [href]="'mailto:' + app.supportEmail"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <mat-icon>email</mat-icon>
    <div class="with-details" fxLayout="column">
      <span>Email support</span>
      <small>{{ app.supportEmail }}</small>
    </div>
  </a>
  <a
    mat-menu-item
    [href]="'tel:' + app.supportPhone"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <mat-icon>phone</mat-icon>
    <div class="with-details" fxLayout="column">
      <span>Call support</span>
      <small>{{ app.supportPhone | phone }}</small>
    </div>
  </a>
  <button
    *ngIf="hasSupportPlan && !requestingAgent"
    mat-menu-item
    (click)="requestAgent($event)"
    [disabled]="startingScreenShare"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <mat-spinner *ngIf="startingScreenShare" diameter="30"></mat-spinner>
    <span *ngIf="startingScreenShare" fxFlex="10px"></span>
    <mat-icon *ngIf="!startingScreenShare">screen_share</mat-icon>
    <div class="with-details" fxLayout="column">
      <span>Request support</span>
      <small *ngIf="agentsAvailable">Support agents are available</small>
    </div>
  </button>
  <!-- <button *ngIf="!zoomMeetingUrl && hasSupportPlan" mat-menu-item (click)="startScreenShare($event)" [disabled]="startingScreenShare" fxLayout="row" fxLayoutAlign="start center">
    <mat-spinner *ngIf="startingScreenShare" diameter="30"></mat-spinner>
    <span fxFlex="10px" *ngIf="startingScreenShare"></span>
    <mat-icon *ngIf="!startingScreenShare">screen_share</mat-icon>
    <span>Screen share</span>
  </button> -->
  <button
    *ngIf="requestingAgent"
    mat-menu-item
    (click)="cancelRequestAgent()"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <mat-spinner
      *ngIf="startingScreenShare || requestingAgent"
      diameter="30"
    ></mat-spinner>
    <span *ngIf="startingScreenShare || requestingAgent" fxFlex="10px"></span>
    <mat-icon *ngIf="!startingScreenShare && !requestingAgent" color="warn"
      >support</mat-icon
    >
    <div class="with-details" fxLayout="column">
      <span class="text-warn"> Cancel support request </span>
      <small *ngIf="requestingAgent && !startingScreenShare" class="text-warn">
        Waiting for agent to join
      </small>
    </div>
  </button>
  <a
    *ngIf="zoomMeetingUrl"
    mat-menu-item
    [href]="zoomMeetingUrl"
    target="_blank"
  >
    <mat-icon>screen_share</mat-icon>
    Enter screen share
  </a>
  <a
    *ngIf="zoomMeetingPhone"
    mat-menu-item
    [href]="'tel:' + zoomMeetingPhone + ',,' + zoomMeetingId + '#'"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <mat-icon>phone</mat-icon>
    <div class="with-details" fxLayout="column">
      <span>Call-in to {{ zoomMeetingPhone | phone }}</span>
      <span>Meeting ID: {{ zoomMeetingId }}</span>
    </div>
  </a>
</mat-menu>
